export default __webpack_public_path__ + "static/media/dashboard-img2.5bff0d30.svg";